module.exports = __webpack_public_path__ + "img/empty-state-list.10a1b8d2.svg";